module.exports = __webpack_public_path__ + "static/media/Source Info.52aaf3a5.md";